import { Typography, styled } from "@mui/material";
/* eslint-disable */
export const Sticky = styled("div")`
	font-size: clamp(6.5px, 1.52vw, 15px);
	position: relative;
	width: 43em;
	height: 8em;
	min-height: 80px;
	flex: 0 0 auto;
	pointer-events: none;

	&.mobile {
		margin-left: 2%;
	}
`;

export const TagBrush = styled("div")`
	position: absolute;
	bottom: 0;
	left: 0;
	background-repeat: no-repeat;
	background-position: center center;
	background-size: 100% 100%;
	height: 4.5333em;
	background-image: url(${(props: any) => props["data-image"]});
	display: flex;
	align-items: center;
	width: 100%;
	cursor: pointer;
	pointer-events: auto;

	&.mobile {
		min-height: 65px;
		.text {
			@media (max-width: 420px) {
				font-size: 1.9em;
				width: 180px;
			}
		}
	}
`;
/* eslint-enable */
export const Body = styled("div")`
	height: 100%;
	margin: 0 auto;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	transform: translateX(6%);
`;

export const Tiki = styled("img")`
	top: 50%;
	left: 1em;
	transform: translateY(-66%);
	position: absolute;
	width: auto;
	height: 9em;
	object-fit: contain;
`;

export const Text = styled(Typography)`
	line-height: 1.2;
	color: #fff;
	font-weight: 600;
	font-size: 1.4em;
`;

export const Button = styled("button")`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	right: 4%;
	background-color: unset;
	border: unset;
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 2em;
	height: 2em;
	border-radius: 100%;
	svg {
		stroke: #fff;
		font-size: inherit;
		width: 2em;
		height: 2em;
	}
`;
